<template>
    <div class="getting-started wrapper">
        <h1>{{content.title}}</h1>
        <div class="row intro-blocks">
            <div class="col c24">
                <section class="overview">
                    <h3>Overview</h3>
                    <div v-html="content.overview"></div>
                </section>
            </div>
        
            <div class="col c24">
                <section>
                    <h3>Goals</h3>
                    <ul>
                        <li v-for="(g, i) in content.goals" :key="'g_' + i">{{ g }}</li>
                    </ul>
                </section>
            </div>

            <div class="col c24">
                <section>
                    <h3>Duration</h3>
                    <p>About {{content.duration}} minutes</p>
                </section>
            </div>
        </div>
        
        <div class="sticky-footer">
            <button id="button" @click="animateOut" class="btn center noselect">Get Started</button>
        </div>
    </div>
</template>

<script>

import { gsap } from '/src/assets/js/gsap';
import { ScrollToPlugin } from '/src/assets/js/gsap/ScrollToPlugin';
import { mapGetters } from 'vuex'

export default {
    name: "Overview",
    methods: {
        animateOut() {
            gsap.to('h1, section, #button', {autoAlpha: 0, stagger: { amount: 0.35}, ease: "back.in"});
            gsap.delayedCall(1, this.next);
        },
        next() {
            this.$router.push({ name: "gettingstarted" });
        }
    },
    mounted () {
        this.$parent.appHeight();
        gsap.registerPlugin(ScrollToPlugin);
        const tl = new gsap.timeline();
        tl.to(window, {duration: 0.5, scrollTo: 0, delay: .2, ease: "sine.out"});
        tl.from('.sticky-footer', {autoAlpha: 0, duration: 0.5, ease: "sine.out"});
        tl.from('h1, section, #button', {autoAlpha: 0, x: "-200px", stagger: { amount: 0.5}, ease: "sine.out"}, "+=0.5");
        
    },
    computed: {
        ...mapGetters([
            'getIntroduction',
        ]),
        content(){
            return this.getIntroduction
        }
    }  
};
</script>
